/**
 * Using .filter(Boolean) doesn't type guard against undefined. This helper will
 * do it instead
 * https://github.com/microsoft/TypeScript/pull/29955
 * @param x
 * @returns
 */
export const filterUndefined = (x: any): x is NonNullable<typeof x> =>
  Boolean(x);
